import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getTrade } from "../../utils/contractHelpers";
import { useRecoilValue } from "recoil";
import { userSmartAccount } from "../../components/RecoilAtom";

const UserLiquidity = () => {
    const smartAccount = useRecoilValue(userSmartAccount)
    const web3 = useWeb3();
    const UserLiquidityHook = useCallback(
        async (address) => {
            const contract = getTrade(address, web3);
            try {
                const liquidity = await contract.methods.userLiquidity(smartAccount).call();
                return liquidity;
            } catch (error) {
                console.error("Error fetching balance:", error.message || error);
                throw error;
            }
        },
        [web3, smartAccount]
    );
    return { UserLiquidityHook };
};

export default UserLiquidity;